import store from "@/store";

let ownSongs = function (artist) {
	return Object.values(store.state.songs).filter(s => {
		return s.artist_ids.includes(artist.id);
	});
};

let sourceSongs = function (artist, role = "artist") {
	return Object.values(store.state.songs).filter(s => {
		return s.parent_id != "" && s[`${role}_ids`].includes(artist.id);
	});
};

let targetSongs = function (artist, role = "artist") {
	return Object.values(store.state.songs).filter(s => {
		return s.parent_id != "" && s.artist_id != "" && store.state.songs[s.parent_id][`${role}_ids`].includes(artist.id);
	});
};

let sourceSongsExact = function (artist, role = "artist") {
	return Object.values(store.state.songs).filter(s => {
		return s.parent_id != "" && s[`${role}_id`] == artist.id;
	});
};

let targetSongsExact = function (artist, role = "artist") {
	return Object.values(store.state.songs).filter(s => {
		return s.parent_id != "" && s[`${role}_id`] != "" && store.state.songs[s.parent_id][`${role}_id`] == artist.id;
	});
};
let ownSongsExact = function (artist) {
	return Object.values(store.state.songs).filter(s => {
		return s.artist_id == artist.id;
	});
};


export { ownSongs, sourceSongs, targetSongs, ownSongsExact, sourceSongsExact, targetSongsExact };
